<template>
  <v-card flat>
    <v-icon class="close" @click="close()">$sl-close</v-icon>
    <v-card-title> Välj teoripaket </v-card-title>
    <v-card-text>
      <v-form ref="form">
        <v-select data-cy="select-teori-paket" outlined return-object
          v-model="distanceCourse"
          :items="computedProvidedCourses"
          item-text="name"
          item-value="id"
          label="Kursnamn"
          :rules="[rules.required]"
        />

        <template v-if="distanceCourse && distanceCourse.assignments && distanceCourse.assignments.length">
          <template v-if="distanceCourse.assignments.length > 1">
            <v-checkbox label="Välj alla" v-model="allSelected"/>
          </template>
          <template v-for="assignment in distanceCourse.assignments">
            <div :key="`${distanceCourse.id}_${assignment.id}`">
              <v-checkbox :label="assignment.name" v-model="selected" :value="assignment.id"></v-checkbox>
            </div>
          </template>
        </template>
      </v-form>
    </v-card-text>

    <v-card-actions class="justify-end">
      <v-btn color="secondary" @click="close()">
        <v-icon>$sl-cancel</v-icon>Avbryt
      </v-btn>
      <v-btn data-cy="save-course-name" @click="save()">
        <v-icon>$sl-check</v-icon>Spara
      </v-btn>
    </v-card-actions>
  </v-card>
</template>


<script>
import { RulesMixin } from '@/components/mixins'

export default {
  name: 'CreateProfessionCourseTheoryCourseModal',

  props: {
    providedCourses: { type: Array, default: () => [] },
    courses: { type: Array, default: () => [] },
    hasAssignments: {
      type: Boolean,
      default: false
    }
  },

  mixins: [RulesMixin],

  data: () => ({
    innerCourse: null,
    selected: [],
  }),

  computed: {
    computedProvidedCourses(){
      return this.providedCourses.map(p => ({
        ...{ ...p, ...{ name: (p.version !== '2.0' && p.distanceEducationProviderId === 1) ? `${ p.name } (gammal)` : p.name } },
        disabled: this.courses.map(c => c.id).includes(p.id) || p.type === 3,
      }))
    },

    assignments(){
      return  !this.innerCourse ? [] : this.innerCourse.assignments || []
    },

    distanceCourse: {
      get(){
        return this.innerCourse
      },
      set(v){
        const assignments = !v ? [] : v.assignments || []
        this.selected = assignments.map(a => a.id)
        this.innerCourse = v
      }
    },

    allSelected: {
      get(){
        if(!this.distanceCourse || !this.distanceCourse.assignments){
          return false;
        }
        return this.assignments.every(a => this.selected.includes(a.id))
      },
      set(v){
        if(!v){
          this.selected = []
        } else {
          this.selected = this.assignments.map(a => a.id)
        }
      }
    }
  },

  methods: {
    close(){
      this.$emit('close')
    },

    save(){
      if(!this.distanceCourse || (!this.selected.length && this.hasAssignments)){
        this.$events.fire('showError', 'Formuläret är inte korrekt ifyllt.')
        return
      }

      const assignments = this.assignments.filter(a => this.selected.includes(a.id)).map(({ id, name }) => ({ id, name }))
      this.$emit('save', { distanceCourseId: this.distanceCourse.id, assignments, type: this.distanceCourse.type })
    }
  }
}
</script>